
    import './styles.scoped.css';
    export default {
  "background": "awsui_background_hyvsj_112by_93",
  "scrolling-background": "awsui_scrolling-background_hyvsj_112by_96",
  "sticky-background": "awsui_sticky-background_hyvsj_112by_102",
  "has-sticky-notifications": "awsui_has-sticky-notifications_hyvsj_112by_110",
  "breadcrumbs": "awsui_breadcrumbs_hyvsj_112by_123",
  "has-sticky-background": "awsui_has-sticky-background_hyvsj_112by_133",
  "drawers-container": "awsui_drawers-container_hyvsj_112by_145",
  "has-open-drawer": "awsui_has-open-drawer_hyvsj_112by_156",
  "disable-body-scroll": "awsui_disable-body-scroll_hyvsj_112by_179",
  "drawers-desktop-triggers-container": "awsui_drawers-desktop-triggers-container_hyvsj_112by_184",
  "has-multiple-triggers": "awsui_has-multiple-triggers_hyvsj_112by_225",
  "drawers-mobile-triggers-container": "awsui_drawers-mobile-triggers-container_hyvsj_112by_235",
  "drawers-trigger-content": "awsui_drawers-trigger-content_hyvsj_112by_239",
  "drawers-trigger-overflow": "awsui_drawers-trigger-overflow_hyvsj_112by_253",
  "drawers-trigger": "awsui_drawers-trigger_hyvsj_112by_239",
  "drawer": "awsui_drawer_hyvsj_112by_145",
  "drawer-content-container": "awsui_drawer-content-container_hyvsj_112by_283",
  "drawer-close-button": "awsui_drawer-close-button_hyvsj_112by_292",
  "drawer-content": "awsui_drawer-content_hyvsj_112by_283",
  "drawer-content-hidden": "awsui_drawer-content-hidden_hyvsj_112by_300",
  "drawer-slider": "awsui_drawer-slider_hyvsj_112by_303",
  "is-drawer-open": "awsui_is-drawer-open_hyvsj_112by_310",
  "content": "awsui_content_hyvsj_112by_336",
  "layout": "awsui_layout_hyvsj_112by_357",
  "has-max-content-width": "awsui_has-max-content-width_hyvsj_112by_440",
  "content-type-dashboard": "awsui_content-type-dashboard_hyvsj_112by_455",
  "content-type-table": "awsui_content-type-table_hyvsj_112by_469",
  "content-type-cards": "awsui_content-type-cards_hyvsj_112by_469",
  "is-overlap-disabled": "awsui_is-overlap-disabled_hyvsj_112by_475",
  "is-hide-mobile-toolbar": "awsui_is-hide-mobile-toolbar_hyvsj_112by_478",
  "has-content-gap-left": "awsui_has-content-gap-left_hyvsj_112by_510",
  "has-content-gap-right": "awsui_has-content-gap-right_hyvsj_112by_513",
  "content-first-child-notifications": "awsui_content-first-child-notifications_hyvsj_112by_523",
  "has-breadcrumbs": "awsui_has-breadcrumbs_hyvsj_112by_526",
  "content-first-child-header": "awsui_content-first-child-header_hyvsj_112by_529",
  "has-header": "awsui_has-header_hyvsj_112by_529",
  "content-first-child-main": "awsui_content-first-child-main_hyvsj_112by_550",
  "disable-content-paddings": "awsui_disable-content-paddings_hyvsj_112by_550",
  "has-split-panel": "awsui_has-split-panel_hyvsj_112by_593",
  "split-panel-position-bottom": "awsui_split-panel-position-bottom_hyvsj_112by_593",
  "block-body-scroll": "awsui_block-body-scroll_hyvsj_112by_609",
  "unfocusable": "awsui_unfocusable_hyvsj_112by_614",
  "container": "awsui_container_hyvsj_112by_624",
  "is-navigation-open": "awsui_is-navigation-open_hyvsj_112by_649",
  "is-tools-open": "awsui_is-tools-open_hyvsj_112by_652",
  "is-split-panel-open": "awsui_is-split-panel-open_hyvsj_112by_652",
  "split-panel-position-side": "awsui_split-panel-position-side_hyvsj_112by_652",
  "has-active-drawer": "awsui_has-active-drawer_hyvsj_112by_652",
  "mobile-toolbar": "awsui_mobile-toolbar_hyvsj_112by_661",
  "remove-high-contrast-header": "awsui_remove-high-contrast-header_hyvsj_112by_677",
  "mobile-toolbar-nav": "awsui_mobile-toolbar-nav_hyvsj_112by_681",
  "mobile-toolbar-breadcrumbs": "awsui_mobile-toolbar-breadcrumbs_hyvsj_112by_685",
  "mobile-toolbar-tools": "awsui_mobile-toolbar-tools_hyvsj_112by_689",
  "navigation-container": "awsui_navigation-container_hyvsj_112by_698",
  "show-navigation": "awsui_show-navigation_hyvsj_112by_742",
  "animating": "awsui_animating_hyvsj_112by_764",
  "showButtons": "awsui_showButtons_hyvsj_112by_1",
  "navigation": "awsui_navigation_hyvsj_112by_698",
  "openNavigation": "awsui_openNavigation_hyvsj_112by_1",
  "animated-content": "awsui_animated-content_hyvsj_112by_826",
  "hide-navigation": "awsui_hide-navigation_hyvsj_112by_835",
  "notifications": "awsui_notifications_hyvsj_112by_845",
  "sticky-notifications": "awsui_sticky-notifications_hyvsj_112by_851",
  "split-panel-bottom": "awsui_split-panel-bottom_hyvsj_112by_868",
  "position-bottom": "awsui_position-bottom_hyvsj_112by_915",
  "openSplitPanelBottom": "awsui_openSplitPanelBottom_hyvsj_112by_1",
  "split-panel-side": "awsui_split-panel-side_hyvsj_112by_944",
  "position-side": "awsui_position-side_hyvsj_112by_957",
  "tools-container": "awsui_tools-container_hyvsj_112by_979",
  "tools": "awsui_tools_hyvsj_112by_979",
  "openTools": "awsui_openTools_hyvsj_112by_1",
  "has-tools-form-persistence": "awsui_has-tools-form-persistence_hyvsj_112by_1076",
  "hide-tools": "awsui_hide-tools_hyvsj_112by_1086",
  "show-tools": "awsui_show-tools_hyvsj_112by_1098",
  "has-tools-form": "awsui_has-tools-form_hyvsj_112by_1076",
  "trigger-badge-wrapper": "awsui_trigger-badge-wrapper_hyvsj_112by_1180",
  "trigger": "awsui_trigger_hyvsj_112by_1180",
  "selected": "awsui_selected_hyvsj_112by_1243",
  "badge": "awsui_badge_hyvsj_112by_1263",
  "trigger-wrapper": "awsui_trigger-wrapper_hyvsj_112by_1267",
  "dot": "awsui_dot_hyvsj_112by_1275"
};
  